import { createFileRoute } from "@tanstack/react-router";
import DepressionTreatmentGoogle from "@/pages/DepressionTreatmentGoogle";
export const Route = createFileRoute("/services/depression-google")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title:
            "Depression Treatment Center in Coral Springs | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Comprehensive depression treatment in Coral Springs, FL. TMS, SAINT, SPRAVATO, ketamine, medication management & psychotherapy. Check your eligibility in.",
        },
        {
          property: "og:title",
          content:
            "Depression Treatment Center in Coral Springs | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Comprehensive depression treatment in Coral Springs, FL. TMS, SAINT, SPRAVATO, ketamine, medication management & psychotherapy. Check your eligibility in.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/services/depression-google",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services/depression-google",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionTreatmentGoogle />;
}
